<template lang="html">
	<div id="page__additional_services_prices" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<AdditionalServicesMenu></AdditionalServicesMenu>
			<sort-table
				v-bind:columns="tableColumns" v-model="prices" v-on:refresh="getPrices" v-bind:per-page="perPage" 
				v-bind:total="pricesAmount" link table-id="additional-services-prices" ref="table" v-on:create="addPrice" tableHeight="calc(100% - 48px)"
			>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import AdditionalServicesMenu from './AdditionalServicesMenu.vue';
	import SortTable from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, ZIconButton, AdditionalServicesMenu },
		data() {
			return {
				title: 'Дополнительные услуги',
				perPage: 50,
				types: {
                    1: 'По весу',
                    2: 'По объёму',
				},
				tableColumns: [
					{ label: 'ID',            field: 'id',           sortable: true },
					{ label: 'Тип',           field: 'type_name',    sortable: true },
					{ label: 'Мин. значение', field: 'value_min',    sortable: true },
					{ label: 'Мкс. значение', field: 'value_max',    sortable: true },
					{ label: 'Услуга',        field: 'service_name', sortable: true },
					{ label: 'Способ оплаты', field: 'payment_method_name', sortable: true },
					{ label: 'Город отправления',       field: 'city_from_name', sortable: false },
					{ label: 'Направление отправления', field: 'zone_from_name', sortable: false },
					{ label: 'Город назначения',        field: 'city_to_name',   sortable: false },
					{ label: 'Направление назначения',  field: 'zone_to_name',   sortable: false },
					{ label: 'Минимальная цена', field: 'is_min_name', sortable: true },
					{ label: 'Цена', field: 'price',  sortable: true },
					{ label: '', field: 'actions' }
				],
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-additional-services-prices-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список цен
			 */
             prices() {
				return this.$store.state.cost.additional_services_prices.map(item => {
					item.payment_method_name = item.payment_method ? item.payment_method.name : 'Не установлен'
					item.routerLink   = {name: 'AdditionalServicesPrice', params: {id: item.id}, query: this.$route.query};
					item.is_min_name  = parseInt(item.is_min) === 1 ? 'Да' : 'Нет'
					item.service_name = item.service ? item.service.name : 'Не установлена'
					item.type_name    = item.type && this.types[item.type] ? this.types[item.type] : 'Не установлен'
					item.city_from_name = item.city_from ? item.city_from.name : 'Не определен'
					item.city_to_name   = item.city_to   ? item.city_to.name   : 'Не определен'
					item.zone_from_name = item.zone_from ? item.zone_from.name : 'Не определено'
					item.zone_to_name   = item.zone_to   ? item.zone_to.name   : 'Не определено'
					return item;
				});
			},
			/**
			 * Количество городов
			 */
             pricesAmount() {
				return this.$store.state.cost.additional_services_prices_amount
			}
		},
		created() {
			this.$store.commit('setTitle', this.title)
		},
		methods: {
			/**
			 * Добавление города
			 */
			addPrice() {
				this.$router.push({ name: 'AdditionalServicesPrice', params: {id: 'new'} });
			},
			/**
			 * Получение городов
			 */
			getPrices(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-additional-services-prices-list');
				return this.$store.dispatch('cost/getAdditionalServicesPrices', {
					page: page, 
					order_by: orderBy, 
					order_type: orderType, 
					count: count,
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-additional-services-prices-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                //if (filter.type)    model.push(['type',    '=', filter.type]);
                //if (filter.city_id) model.push(['city_id', '=', filter.city_id]);
                //if (filter.zone_id) model.push(['zone_id', '=', filter.zone_id]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });

				return result;
			},
			/**
			 * Удаление города
			 */
			removePrice(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-additional-services-prices-list');
				this.$store.dispatch('cost/deleteAdditionalServicesPrice', id)
					.then(() => this.$root.$emit('refresh-table', 'additional-services-prices'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-additional-services-prices-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления города
			 */
			onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removePrice(id)
                );
            },
		},
	}
</script>


// WEBPACK FOOTER //
// AdditionalServicesPrices.vue?51f8c087